// Hook: GET /company/users?location_id=X&department_id=Y&unassigned=true - lista userow firmy

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import { ICompanyUser } from 'api/types/company';

export interface IRequest {
  location_id?: number;
  department_id?: number;
  // unassigned=true zwraca tylko userow klienta BEZ rekordu CompanyUser
  // (do przypisywania istniejacych userow przy upgrade'ie wdrozenia)
  unassigned?: boolean;
}

export interface IResponse {
  items: ICompanyUser[];
  total?: number;
}

const getCompanyUsers = (params?: IRequest): Promise<IResponse> =>
  axios.get('/company/users', { params });

export const useGetCompanyUsers = (
  params?: IRequest,
  options?: UseQueryOptions<IResponse, IError>
) =>
  useQuery<IResponse, IError>(
    [
      'company',
      'users',
      params?.location_id ?? 'all',
      params?.department_id ?? 'all',
      params?.unassigned ? 'unassigned' : 'all'
    ],
    () => getCompanyUsers(params),
    options
  );
